var $$ = $$ || {};

$$.RegistrationPage = class ProfilePage {
	constructor (root, options = {}) {
		var defaultOptions = {};
		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.formStates = {
			closed: 'g-icon-eye-closed',
			opened: 'g-icon-eye-opened'
		};

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			addNumber:     this.root.find('.js-add-number'),
			eye:           this.root.find('.js-eye'),
			passwordInput: this.root.find('.js-password-input'),
			phone: this.root.find('.phone')
		};
	}

	_bindEvents () {
		var phoneTemplate = `<input class="input phone" name="REGISTER[PERSONAL_PHONE]" id="phone1" type="text">`;

		this.nodes.addNumber.one('click', (event) => {
			"use strict";
			event.preventDefault();
			var item = $(event.currentTarget);

			if (item.parent().find('input').length >= 2) {
				return;
			}

			var newPhoneField = $(phoneTemplate)
				.appendTo(item.parent())
				.on("focusout", (event) => this._clearBrokenPhoneNumber(event));

			this._initMask(newPhoneField);

			$(event.currentTarget).remove();
		});

		this.nodes.eye.on('click', () => {
			this._togglePasswordInput();
		});

		this.root.find('form').on('submit', (event) => {
			"use strict";
			event.preventDefault();

			var form = $(event.currentTarget);
			form.find(`input`).removeClass('error');

			/**
			 REGISTER[LOGIN] = REGISTER[EMAIL]
			 REGISTER[CONFIRM_PASSWORD] = REGISTER[PASSWORD]
			 */

			form.find('[name="REGISTER[LOGIN]"]').val(form.find('[name="REGISTER[EMAIL]"]').val());
			form.find('[name="REGISTER[CONFIRM_PASSWORD]"]').val(form.find('[name="REGISTER[PASSWORD]"]').val());

			$.ajax({
				url:     form.attr('action'),
				method:  form.attr('method'),
				data:    form.serialize(),
				success: (response) => {
					response = $.parseJSON(response);

					if (response.success) {
						$$.Noty[ 'successMessage' ](response.success);
						this.root.trigger('registrationFormSubmit');

						if (response.redirect) {
							window.location = response.redirect;
						}
					} else {
						_.each(response.errors, function (value, key) {
							form.find(`input[name="${key}"]`).addClass('error');
							$$.Noty[ 'errorMessage' ](value, 4000);
						});
					}
				}
			});

		});

		this.nodes.phone.on("focusout", (event) => this._clearBrokenPhoneNumber(event));
	}

	/**
	 *
	 * @param selector jQuery объект
	 * @private
	 */

	_initMask (selector) {
		"use strict";

		var im = new Inputmask("8 (999) 999-99-99");
		im.mask(selector.get(0));
	}

	_clearBrokenPhoneNumber (event) {
		if ( $(event.currentTarget).val().indexOf("_") > 0 ) {
			$(event.currentTarget).val("");
		}
	}

	_togglePasswordInput () {
		if (this.nodes.eye.hasClass(this.formStates.opened)) {
			this.nodes.eye.removeClass(this.formStates.opened);
			this.nodes.eye.addClass(this.formStates.closed);
			this.nodes.passwordInput.attr('type', 'password');
		} else if (this.nodes.eye.hasClass(this.formStates.closed)) {
			this.nodes.eye.removeClass(this.formStates.closed);
			this.nodes.eye.addClass(this.formStates.opened);
			this.nodes.passwordInput.attr('type', 'text');
		}
	}

	_ready () {
		"use strict";
		this.root.find('input.phone').each((index, element) => {
			this._initMask($(element));
		});
	}
};
